module.exports = __webpack_public_path__ + "img/niño63.7a785f5b.jpg";